import { render, staticRenderFns } from "./areaAdd.vue?vue&type=template&id=9ae2b2aa&scoped=true"
import script from "./areaAdd.vue?vue&type=script&lang=js"
export * from "./areaAdd.vue?vue&type=script&lang=js"
import style0 from "./areaAdd.vue?vue&type=style&index=0&id=9ae2b2aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ae2b2aa",
  null
  
)

export default component.exports